import React, { FC } from 'react';
import PartnersCardFooter from './partners-card-footer';
import PartnersCardBody from './partners-card-body';
import './styles.scss';
import { PartnerType } from 'models/partner.model';

type PartnersCardProps = {
  isActive: boolean;
  onClick: (item: any) => void;
  partner: PartnerType;
  handleDeletePartner: (id: string) => void;
};

const PartnersCard: FC<PartnersCardProps> = ({
  isActive,
  onClick,
  partner,
  handleDeletePartner
}) => {
  return (
    <div className={`partners-card ${isActive ? 'partners-card-active' : ''}`}>
      <PartnersCardBody partner={partner} onClick={onClick} />
      <PartnersCardFooter partner={partner} handleDeletePartner={handleDeletePartner} />
    </div>
  );
};

export default PartnersCard;
